import { render, staticRenderFns } from "./document-name-codification.vue?vue&type=template&id=1440fe70"
import script from "./document-name-codification.vue?vue&type=script&lang=js"
export * from "./document-name-codification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports